import farhana from '../img/farhana.jpg'
import mishuk from '../img/mishuk.jpg'
import saimon from '../img/saimon.jpg'

const TestimonialApi = [
  {
    id: 1,
    image: mishuk,
    design: "The Purple Algorithm",
    name: "Jahidul Alam Mishuk",
    offcer: "Senior Software Engineer",
    post: "CEO - Marketing",
    date: "Thoda Department - Mar 4, 2018 - Aug 30, 2021",
    desc: "As a junior web developer, Md Hasanul Karim has consistently impressed with their dedication, creativity, and problem-solving skills. His ability to learn new concepts quickly and apply them effectively has been a tremendous asset to our team. Md Hasanul Karim consistently delivers high-quality work, exceeding expectations with every project they undertake. His positive attitude and willingness to collaborate make us a joy to work with. I highly recommend Md Hasanul Karim for his exceptional contributions and look forward to witnessing their continued growth and success in the field of Web development.",
  },
  {
    id: 2,
    image: farhana,
    design: "Programming Hero",
    name: "Gazi Tasnuva Farhana",
    offcer: "Job Placement Executive",
    post: "Android App Development",
    date: "via Upwork - Mar 4, 2015 - Aug 30, 2021",
    desc: "Working alongside Md Hasanul Karim as a Job Mentor has been a refreshing experience. His unwavering commitment to excellence shines through in every task undertake. His approaches challenges with enthusiasm, consistently finding innovative solutions that surpass expectations. His strong work ethic, coupled with their ability to adapt to evolving technologies, sets them apart. His positive attitude and collaborative spirit make us an invaluable student of our Institute. I highly recommend him for his exceptional contributions and look forward to witnessing his continued success in the field of Web development.",
  },
  {
    id: 3,
    image: saimon,
    design: "Tulip Tech",
    name: "Sadiqul Alam Saimon",
    offcer: "SQA Lead",
    post: "Android App Development",
    date: "via Upwork - Mar 4, 2015 - Aug 30, 2021",
    desc: "In the dynamic world of web development, Md Hasanul Karim stands out as a beacon of talent and dedication. His work embodies the perfect fusion of artistry and functionality, showcasing a meticulous attention to detail and a flair for innovation. With each project, He demonstrates an unwavering commitment to excellence, delivering results that exceed expectations. His passion for learning is infectious, inspiring the entire team to reach new heights of creativity. His contributions have been nothing short of exceptional, and I have no doubt that their future in web development will be nothing less than brilliant.",
  },
];

export default TestimonialApi;
